import { render, staticRenderFns } from "./PeopleSwiper.vue?vue&type=template&id=0492622a&scoped=true"
import script from "./PeopleSwiper.vue?vue&type=script&lang=js"
export * from "./PeopleSwiper.vue?vue&type=script&lang=js"
import style0 from "./PeopleSwiper.vue?vue&type=style&index=0&id=0492622a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0492622a",
  null
  
)

export default component.exports